import { render, staticRenderFns } from "./WWizard.vue?vue&type=template&id=7af572b8&scoped=true&"
import script from "./WWizard.vue?vue&type=script&lang=ts&"
export * from "./WWizard.vue?vue&type=script&lang=ts&"
import style0 from "./WWizard.vue?vue&type=style&index=0&id=7af572b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af572b8",
  null
  
)

export default component.exports